import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ITFlagIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="8.88889" fill="#F2F0F2" />
      <mask
        id="mask0_it_flag"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="18"
        height="18"
      >
        <circle cx="10" cy="10" r="8.88889" fill="#FCFCFC" />
      </mask>
      <g mask="url(#mask0_it_flag)">
        <rect
          x="1.11111"
          y="1.11111"
          width="17.7778"
          height="17.7778"
          fill="#F2F0F2"
        />
        <rect
          x="1.11111"
          y="1.11111"
          width="5.92593"
          height="17.7778"
          fill="#00A03E"
        />
        <rect
          x="13.0741"
          y="1.11111"
          width="5.92593"
          height="17.7778"
          fill="#D90026"
        />
      </g>
    </BaseIcon>
  );
};

ITFlagIcon.displayName = 'ITFlagIcon';
